import React from "react";

const faqs = [
  {
    q: "¿Dónde se encuentra ubicada la Oficina Privilege HB?",
    a: (
      <>
        <p>
          La Oficina Privilege HB se encuentra en el Hospital Británico Central, ubicado en Perdriel 74, C1280AEB-Ciudad Autónoma de Buenos Aires. Planta Baja, pasillo 1.
        </p>
        <p>
          De manera presencial de lunes a viernes de 08:00 a 20 hs. En nuestra oficina en el Hospital Británico Central ubicado en Planta Baja, pasillo 1.
        </p>
      </>
    ),
  },
  {
    q: "¿Cuáles son los canales para contactar a Privilege HB si necesito realizar una consulta?",
    a: (
      <div>
        <p>Puede contactar a Privilege HB a través de estos canales:</p>
        <ul>
          <li>Teléfono: (+54) 4309-6899</li>
          <li>Chat institucional: 11-3015-9749 opción 7</li>
          <li>Correo electrónico: privilegehb@hbritanico.com.ar</li>
        </ul>
      </div>
    ),
  },
  {
    q: "¿Quiénes pueden acceder a los servicios de Privilege HB?",
    a: (
      <p>
        Los servicios de Privilege están disponibles para cualquier persona sin cobertura médica que requiera una atención personalizada de manera privada.
      </p>
    ),
  },
  {
    q: "¿Es necesario ser paciente del Hospital Británico para utilizar Privilege HB?",
    a: (
      <p>
        No, no es necesario ser paciente del Hospital Británico. El servicio de Privilege está abierto a cualquier persona sin cobertura médica que desee acceder a la atención médica de alta calidad, personalizada y de manera privada.
      </p>
    ),
  },
  {
    q: "¿Cuáles son los métodos de pago aceptados para los turnos de consulta y estudios médicos?",
    a: (
      <div>
        <p>Aceptamos los siguientes métodos de pago:</p>
        <ul>
          <li>Tarjetas de crédito</li>
          <li>Tarjetas de débito</li>
          <li>Transferencia bancaria</li>
          <li>Mercado Pago</li>
        </ul>
      </div>
    ),
  },
  {
    q: "¿Cómo puedo solicitar un turno en Privilege HB?",
    a: (
      <div>
        <p>Puede solicitar un turno en Privilege HB de las siguientes maneras:</p>
        <ul>
          <li>Por el chat institucional al 11-3015-9749 opción 7.</li>
          <li>De manera presencial de lunes a viernes de 08:00 a 20 hs. En nuestra oficina en el Hospital Británico Central ubicado en Planta Baja, pasillo 1.</li>
          <li>Por correo electrónico a <a href="mailto:privilegeHB@hbritanico.com.ar">privilegeHB@hbritanico.com.ar</a>.</li>
        </ul>
      </div>
    ),
  },
  {
    q: "¿Qué debo hacer si necesito cambiar o cancelar mi turno?",
    a: (
      <div>
        <p>
          Si necesita modificar o cancelar tu turno, le pedimos que lo haga con un mínimo de 48 horas de anticipación
        </p>
        <ul>
          <li>Por el chat institucional al 11-3015-9749 opción 7.</li>
          <li>De manera presencial de lunes a viernes de 08:00 a 20 hs. En nuestra oficina en el Hospital Británico Central ubicado en Planta Baja, pasillo 1.</li>
        </ul>
      </div>
    ),
  },
  {
    q: "¿Qué documentación necesito presentar el día de mi turno para la atención?",
    a: (
      <p>
        El día del turno deberá presentar su documento de identidad (DNI, pasaporte, etc.). Si tiene una orden médica, también debe traerla. Las asistentes le informarán todo lo necesario al momento de otorgarle el turno.
      </p>
    ),
  },
  {
    q: "¿Cuenta con servicio de traducción disponible para pacientes que no hablan español?",
    a: <p>Sí, contamos con un servicio de traducción disponible para aquellos pacientes que lo necesiten.</p>,
  },
  {
    q: "¿Puedo recibir un presupuesto estimado para mi tratamiento antes de viajar?",
    a: <p>Sí, podemos brindarle un presupuesto estimado de su tratamiento o estudio. Para ello, es necesario que nos envíe la orden médica.</p>,
  },
  {
    q: "¿Cómo puedo coordinar mi atención médica si viajo desde el exterior?",
    a: (
      <p>
        Para coordinar su atención desde el exterior, le recomendamos contactar a nuestras asistentes. Ellas se encargarán de ayudarlo con la programación de turnos, la traducción y otros servicios para que su experiencia sea lo más sencilla y positiva posible.
      </p>
    ),
  },
];

const PreguntasFrecuentes = () => {
  const [openIndex, setOpenIndex] = React.useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <div className="card p-4 b-radius-10">
      <h2 style={{ color: "#05294F" }}><strong>Preguntas frecuentes</strong></h2>
      <hr />

      <div
        className="accordion w-100"
        id="faqAccordion"
        style={{
          "--bs-accordion-border-color": "#dee2e6",
          "--bs-accordion-active-bg": "transparent",
          "--bs-accordion-active-color": "inherit",
          "--bs-accordion-btn-focus-box-shadow": "none",
          "--bs-accordion-btn-color": "inherit",
          fontFamily: "inherit",
        }}
      >
        {faqs.map((item, idx) => {
          const headingId = `faq-heading-${idx}`;
          const panelId = `faq-panel-${idx}`;
          const isOpen = openIndex === idx;
          return (
            <div
              className="accordion-item w-100 border-start-0 border-end-0 rounded-0 shadow-none"
              key={idx}
              style={{
                borderColor: "#dee2e6",
                borderTop: idx === 0 ? "0" : undefined,
                borderBottom: isOpen ? "0" : undefined,
              }}
            >
              <h3 className="accordion-header" id={headingId}>
                <button
                  className={`accordion-button w-100 shadow-none ${isOpen ? "" : "collapsed"}`}
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => toggle(idx)}
                  style={{
                    fontWeight: "bold",
                    boxShadow: "none",
                    outline: "none",
                    backgroundColor: isOpen ? "transparent" : undefined,
                    color: "inherit",
                    borderBottom: isOpen ? "0" : undefined,
                    fontFamily: "inherit",
                  }}
                >
                  {item.q}
                </button>
              </h3>
              <div
                id={panelId}
                role="region"
                aria-labelledby={headingId}
                className={`accordion-collapse collapse w-100 border-start-0 border-end-0 shadow-none ${isOpen ? "show" : ""}`}
                // No dependemos del JS de Bootstrap; mostramos/ocultamos vía clases
              >
                <div className="accordion-body w-100 shadow-none">{item.a}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PreguntasFrecuentes;